<template lang="pug">
  .height-100
    //- h3.title Reportes de boletas pendientes de generar
    //- p

    transition-group.contenedor-box(name="fade-smooth-two", tag="div")
      .box.position-relative(v-if="mostrarReporteBoletasPendientes", key="reporte_boletas")
        lista-boletas-pendientes(
          @close="mostrarReporteBoletasPendientes = false"
        )

</template>

<script>
import ListaBoletasPendientes from './Component_Boletas_Pendientes_Lista'
export default {
  name: 'boletas-pendientes',
  components: {
    'lista-boletas-pendientes': ListaBoletasPendientes
  },
  data () {
    return {
      mostrarReporteBoletasPendientes: true
    }
  },
  watch : {
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .contenedor-box
    display flex
    justify-content center
    flex-direction column
    position relative
    >*
      transition all .5s
      width 100%
</style>



// WEBPACK FOOTER //
// View_Boletas_Pendientes_Generar.vue?4d9b9a1d